var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es272.js.map
